
import { defineComponent } from "vue";
import VoerroTagsInput from "@/modules/games/components/tabGamePage/gamesTabGamePageVoerroTagsInputComponent.vue";
import GameDetails from "@/_models/GameDetails";
import ResponseData from "@/_models/ResponseData";
import GameService from "@/services/GameService";
import { Helper } from "@/utils/Helper";
import GameTags from "@/utils/GameTags.json";
import store from "@/store/index";

export default defineComponent({
  props: ["gameData", "getGameDetails", "imageFiles"],
  data: function () {
    return {
      details: {
        ContentRating: "",
        Category: "",
      } as GameDetails,
      selectedTags: [],
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
      viewrow: false,
      hasChanged: false,
      interval: "",
      tags: [],
      original_tags: [],

      // tagListClientInput: [],
      // tagListDB: [],

      existingTags: Object.entries(GameTags)[0][1],
      rows: [
        { name: "English", audio: false, interface: false, subtitles: false },
        { name: "French", audio: false, interface: false, subtitles: false },
      ],

      language: "Arabic",
      subtitles: false,
      audio: false,
      languageInterface: false,

      languageList: [
        {
          code: "ar",
          name: "Arabic",
        },

        {
          code: "eo",
          name: "Esperanto",
        },
        {
          code: "et",
          name: "Estonian",
        },
      ],
    };
  },
  name: 'gamesTabGamePageDetailsComponent',
  components: {
    "tags-input": VoerroTagsInput,
  },
  methods: {
    updateGameDetails() {
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.gameId !== undefined) {
        let gameId = this.$route.params.gameId.toString();
        let formData = new FormData();

        if (this.details.ContentRating !== "" && this.details.ContentRating !== this.gameData.game.contentRating) {
          formData.append("ContentRating", this.details.ContentRating);
        }

        if (this.details.Category !== "" && this.details.Category !== this.gameData.game.Category) {
          formData.append("Category", this.details.Category);
        }

        if(this.selectedTags.length > 0){
          let tags = [];
          tags = this.selectedTags.map((tag: any) => {
            return tag.value;
          })
          formData.append("Tags", JSON.stringify(tags));
        }

        if (this.rows !== []) {
          let languages = [];
          let langObj = {
            Name: "",
            Audio: false,
            Interface: false,
            Subtitles: false,
          };

          this.rows.forEach(function (language: any) {
            langObj = {
              Name: language.name,
              Audio: language.audio,
              Interface: language.interface,
              Subtitles: language.subtitles,
            };
            languages.push(langObj);
          });

          if (this.viewrow && this.language !== "") {
            langObj = {
              Name: this.language,
              Audio: this.audio,
              Interface: this.languageInterface,
              Subtitles: this.subtitles,
            };

            languages.push(langObj);
          }
          this.selectedLanguages = languages;
          formData.append("Languages", JSON.stringify(this.selectedLanguages));
        }

        if (this.imageFiles.imageFile !== "") {
          formData.append("LogoStream", this.imageFiles.imageFile[0]);
        }

        if (this.imageFiles.coverImageFile !== "") {
          formData.append("HeaderImageStream", this.imageFiles.coverImageFile[0]);
        }

        GameService.updateGameDetails(gameId, this.userData.userId, this.jwtToken, formData)
          .then((response: ResponseData) => {
            // $(".tags-input-badge").remove();
            Helper.toastSuccessHandling(response.data['message']);
            this.getGameDetails();
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
      }
    },

    inputHasChanged(modelName: string, gameData: any) {
      if (modelName !== gameData) {
        this.hasChanged = true;
      }
    },

    // add tags to the tempList
    onTagAdded(tag:any) {
      let tagIndex = this.original_tags.findIndex((original_tag:any) => original_tag.value == tag.value);
      if(tagIndex == -1 ){
        this.selectedTags.push({key: tag.value, value: tag.value});
        this.inputHasChanged(this.selectedTags, '');
      }
    },

    //remove tags from the input field
    onTagRemoved(tag:any) {
      let filter = this.selectedTags.filter(function (selectedTag) {
        return selectedTag.value != tag.value;
      });
      this.selectedTags = filter;
      this.inputHasChanged(this.selectedTags, '')
    },


    populateGameDetails() {
      if(this.gameData.game.tags){
        this.selectedTags = this.gameData.game.tags.map((tag: string) => {
          return {
            key: tag,
            value: tag
          }
        }); // using this list to display tags from DB
        this.original_tags = this.selectedTags;
      }
      if (this.gameData.game.contentRating) {
        this.details.ContentRating = this.gameData.game.contentRating;
      }

      if (this.gameData.game.category) {
        this.details.Category = this.gameData.game.category;
      }

      if (this.gameData.game.languages.length > 0) {
        this.rows = this.gameData.game.languages;
        let languages = this.languageList;

        this.rows.forEach(function (languageName) {
          languages = languages.filter(function (language) {
            return language.name !== languageName.name;
          });
        });

        this.languageList = languages;
      }
    },
  },

  created() {
    this.populateGameDetails();
  },
});
